module.exports = __webpack_public_path__ + "img/03.fa083ce7.jpg";